// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d3a22e0b","938":"edbb92ad"}[chunkId] + ".chunk.js";
};